/**
 * Storefront-/locale-aware low-level formatting helpers.
 *
 * Kept deliberately tiny and list-driven so a new storefront/locale is a
 * one-line change instead of another inline ternary in a component.
 * CH stays byte-identical (apostrophe grouping, de-CH dates).
 */

/** Thousands grouping: CH uses ’, every other storefront uses a dot. */
export function groupIntFor(sf: string, n: number): string {
  const sep = sf === 'ch' ? '\u2019' : '.';
  return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, sep);
}

const DATE_LOCALES: Record<string, string> = {
  sq: 'sq-AL',
};

/** Intl date locale for a UI locale. Defaults to de-CH (historical behaviour). */
export function dateLocaleFor(locale: string): string {
  return DATE_LOCALES[locale] ?? 'de-CH';
}
